var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75122 38.5026C2.75122 28.8362 10.5874 21 20.2539 21C29.9203 21 37.7565 28.8362 37.7565 38.5026V39.9029H2.75122V38.5026Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0661 8.98494C29.0661 13.9472 25.0434 17.9699 20.0811 17.9699C15.1189 17.9699 11.0962 13.9472 11.0962 8.98494C11.0962 4.0227 15.1189 0 20.0811 0C25.0434 0 29.0661 4.0227 29.0661 8.98494Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_User.61fb0851302ba0216ba0c73d17c45f01.svg";
export { ForwardRef as ReactComponent };